import React, { useState } from 'react';

const stats = {
    clients: 120,
    projects: 350,
    reactions: '🌟🌟🌟🌟🌟'
};


const GlobalFootprint = () => {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            style={{
               
                maxWidth: 400,
                margin: '40px auto',
                padding: 32,
                borderRadius: 16,
                boxShadow: hovered
                    ? '0 8px 32px rgba(0,0,0,0.18)'
                    : '0 4px 16px rgba(0,0,0,0.10)',
                background: hovered
                    ? 'linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)'
                    : '#fff',
                transition: 'all 0.3s cubic-bezier(.4,2,.6,1)'
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <section>
                <h2 style={{ marginBottom: 12, color: '#1a237e' }}>
                    Global Footprint
                </h2>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                    <div>
                        <strong style={{ fontSize: 28 }}>{stats.clients}+</strong>
                        <div style={{ color: '#050505' }}>Clients</div>
                    </div>
                    <div>
                        <strong style={{ fontSize: 28 }}>{stats.projects}+</strong>
                        <div style={{ color: '#050505' }}>Projects</div>
                    </div>
                </div>
                <div
                    style={{
                        fontSize: 22,
                        color: hovered ? '#ffb300' : '#757575',
                        transition: 'color 0.3s'
                    }}
                >
                    Client Reactions: {stats.reactions}
                </div>
            </section>
        </div>
    );
};

export default GlobalFootprint;